import { render, staticRenderFns } from "./WorksScreen.vue?vue&type=template&id=5fb04565&scoped=true&"
import script from "./WorksScreen.vue?vue&type=script&lang=js&"
export * from "./WorksScreen.vue?vue&type=script&lang=js&"
import style0 from "./WorksScreen.vue?vue&type=style&index=0&id=5fb04565&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb04565",
  null
  
)

export default component.exports